module.exports = __webpack_public_path__ + "static/media/greenlambo.6f326885.jpg";